module.exports = __webpack_public_path__ + "media/images/background-indicator-burnout-ea8ac41a8872fcc861de1d7649a232f5.png";